var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.finish)?_c('v-icon',{attrs:{"color":"accent"}},[_vm._v(" mdi-checkbox-marked-circle-plus-outline ")]):_vm._e(),(!_vm.finish)?_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" mdi-checkbox-blank-circle-outline ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }